import {
    createSlice
} from '@reduxjs/toolkit';

const initialState = {
    showDrawer: false,
    displayMode: false,
    editMode: false,
    currentNode: false,
    showCategories: true,
    showFields: true,
    showOnlyPath: false,
    showThesaurus: false,
    categoryExpanded: [],
    categorySelected: null,
    fieldSelected: null,
    thesaurusSelected: null,
    thesaurusExpanded: [],
    filterNonThesaurus: true,
    thesaurusOpened: [],
    fieldsOpened: [],
    fieldThesaurusExpanded: {},

    // used for communication between selector and object editor
    inputThesaurus: null,
    inputThesaurusValue: null
};

const selectorSlice = createSlice({
    name: 'currentUser',
    initialState,
    reducers: {
        showDrawer(state) {                             state.showDrawer =          true},
        hideDrawer(state) {                             state.showDrawer =          false},
        setDrawer(state, action) {                      state.showDrawer =          action.payload},
        setEditMode(state, action) {                    state.editMode =            action.payload},

        setShowOnlyPath(state, action) {                state.showOnlyPath =        action.payload},
        setShowCategories(state, action) {              state.showCategories =      action.payload},
        setShowFields(state, action) {                  state.showFields =          action.payload},
        setShowThesaurus(state, action) {               state.showThesaurus =       action.payload},

        setFilterNonThesaurus(state, action) {          state.filterNonThesaurus =  action.payload},

        setCategoryExpanded(state, action) {            state.categoryExpanded =    action.payload},
        setCategorySelected(state, action) {            state.categorySelected =    action.payload},

        setThesaurusSelected(state, action) {           state.thesaurusSelected =   action.payload},
        setThesaurusExpanded(state, action) {           state.thesaurusExpanded =   action.payload},

        setFieldSelected(state, action) {               state.fieldSelected =       action.payload},

        setFieldsOpened(state, action) {                state.fieldsOpened =        action.payload},
        addFieldsOpened(state, action) {                state.fieldsOpened =    [...state.fieldsOpened, action.payload]},
        removeFieldsOpened(state, action) {             state.fieldsOpened =        state.fieldsOpened.filter(t=>t!==action.payload)},

        setThesaurusOpened(state, action) {             state.thesaurusOpened =     action.payload},
        addThesaurusOpened(state, action) {             state.thesaurusOpened = [...state.thesaurusOpened, action.payload]},
        removeThesaurusOpened(state, action) {          state.thesaurusOpened =     state.thesaurusOpened.filter(t=>t!==action.payload)},

        setFieldThesaurusExpanded(state, action) {      state.thesaurusExpanded =   {...state.thesaurusExpanded, [action.payload.field]: action.payload.values}},
        addFieldThesaurusExpanded(state, action) {      state.thesaurusExpanded[action.payload.field] = [...state.thesaurusExpanded[action.payload.field], action.value]},
        removeFieldThesaurusExpanded(state, action) {   state.thesaurusExpanded[action.payload.field] =     state.thesaurusExpanded[action.payload.field].filter(t=>t!==action.payload.value)},

        setInputThesaurus(state, action) {              state.inputThesaurus =      action.payload},
        setInputThesaurusValue(state, action) {         state.inputThesaurusValue = action.payload},
    }
});

export default selectorSlice.reducer

export const {
    showDrawer, hideDrawer, setDrawer, setShowOnlyPath,
    setShowFields, setShowCategories, setShowThesaurus,
    setCategoryExpanded, setThesaurusExpanded,
    setCategorySelected, setThesaurusSelected, setFieldSelected,
    setFilterNonThesaurus,
    setThesaurusOpened, addThesaurusOpened, removeThesaurusOpened,
    setFieldsOpened, addFieldsOpened, removeFieldsOpened,
    setFieldThesaurusExpanded, removeFieldThesaurusExpanded, addFieldThesaurusExpanded,
    setEditMode, setInputThesaurus, setInputThesaurusValue
} = selectorSlice.actions;

export const selectDrawerVisible =          (state) => state.drawerSelector.showDrawer;
export const selectEditMode =               (state) => state.drawerSelector.editMode;
export const selectShowOnlyPath =           (state) => state.drawerSelector.showOnlyPath;
export const selectShowCategories =         (state) => state.drawerSelector.showCategories;
export const selectShowFields =             (state) => state.drawerSelector.showFields;
export const selectShowThesaurus =          (state) => state.drawerSelector.showThesaurus;
export const selectCategoryExpanded =       (state) => state.drawerSelector.categoryExpanded;
export const selectCategorySelected =       (state) => state.drawerSelector.categorySelected;
export const selectFieldSelected =          (state) => state.drawerSelector.fieldSelected;
export const selectThesaurusSelected =      (state) => state.drawerSelector.thesaurusSelected;
export const selectThesaurusExpanded =      (state) => state.drawerSelector.thesaurusExpanded;
export const selectFilterNonThesaurus =     (state) => state.drawerSelector.filterNonThesaurus;
export const selectThesaurusOpened =        (state) => state.drawerSelector.thesaurusOpened;
export const selectFieldsOpened =           (state) => state.drawerSelector.fieldsOpened;
export const selectFieldThesaurusExpanded = (state) => state.drawerSelector.fieldThesaurusExpanded;
export const selectInputThesaurus =         (state) => state.drawerSelector.inputThesaurus;
export const selectInputThesaurusValue =    (state) => state.drawerSelector.inputThesaurusValue;
